import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poDisclaimerRepository } from '@webapp/modules/purchasing/data-access/repositories/PODisclaimerRepository'
import { type PODisclaimerLabel } from '@webapp/modules/purchasing/entities/PODisclaimerLabel'
import { poDisclaimerLabelQueryConfig } from '@webapp/modules/purchasing/query-configs/poDisclaimerLabel'

export type PODisclaimerLabelEditableField = 'description' | 'text'

interface EditPODisclaimerLabelMutationVariables {
  label: PODisclaimerLabel
  field: PODisclaimerLabelEditableField
  value: string
}

export const useMutateEditPODisclaimerLabel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    void,
    RepoError,
    EditPODisclaimerLabelMutationVariables
  >({
    // PUT the merged row — the edited field replaced, the other carried over
    // (BHV-022)
    mutationFn: ({ label, field, value }) =>
      poDisclaimerRepository.update(label.id, {
        description: field === 'description' ? value : label.description,
        text: field === 'text' ? value : label.text,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: poDisclaimerLabelQueryConfig.all().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
